<template>
	
	<div style="width:580px;margin:0px auto 0 auto;padding:10px">

        <div style="width:96%；margin:0px auto" v-loading="formLoading">
          <h5  class="board-subject">
            <span  class="float-left ml-1">보낸사람 :{{attn}}({{mem_name}})  </span>
            <span  class="float-right mr-1">받는사람 :{{add_date}} </span>
          </h5> 
          <div  class="board-content">
            <div >{{wr_content}}</div>
          </div> 
         </div>
        <!-- <div class="d-flex mt-2" style="justify-content:center"<el-button type="primary" @click="bonSumbit">{{$t('msg.수정')}}</el-button></div> -->
        
        
    

	</div>
</template>
<script>
	export default{
		props:{
		  info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
    
      layerid:{
        type:String,
        default:""
      },
		
		},
      created() {

       

          // this.info.id父组件传给子组件的id值
          
          this.fetchManage(this.info.id);
        
         
        
    },
		computed: {
         
            
        },
    	data(){
    		return{
          attn:'',
          mem_name:'',
          add_date:'',
         wr_content:'',
         formLoading:false,           
           
          
            domain:window.sessionStorage.getItem('domain'),
            userid:window.sessionStorage.getItem('userid'),
            sitetype:window.sessionStorage.getItem('sitetype'),
            aid:window.sessionStorage.getItem('admin_id'),
            power:window.sessionStorage.getItem('power'),
            rosing:window.sessionStorage.getItem('rosing'),
    			
    		}
    	},
       mounted() {
        
            
    },
    	methods:{
         
      
         fetchManage(id){
          console.log(id)
            this.formLoading = true
            let token=window.sessionStorage.getItem('user');
            let that=this
            this.$axios({
                  method:'get',
                 
                   url:this.domain+'/admin/memo?idx='+id,

                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.formLoading = false
                   let data = response.data.data
                   console.log(response.data.data)
               
                   
                    
                      this.wr_content=data.wr_1
                      this.attn=data.attn
                      this.mem_name=data.mem_name
                      this.add_date=data.add_date
                      
                     
                    

                   
                     
               
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
      },
        

       
    	
    	}
	}
</script>
<style>
.board-subject {
    
    text-align: center;
    width: 100%;
    border-radius: 2px 2px 0 0;
    position: relative;
    height: 40px;
    line-height: 40px;
    font-weight: normal;
    background: #686868;
    
    box-shadow: inset 0 1px 0 hsla(0,0%,100%,.06);
    margin: 0;
    font-size: 16px;
    color: #fff;
  }
  .board-content{
    border: 2px solid #686868;
    border-top: 0;
    min-height: 250px;
    padding: 20px;
    margin-bottom: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/common/wr-dialog.vue